// #region Imports

import { Table } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import type { DataReglementType, FactureType } from '@/types';
import ModalAffectationReglementTableBodyRow from './ModalAffectationReglementTableBodyRow';
import ModalAffectationReglementTableFooter from './ModalAffectationReglementTableFooter';
import ModalAffectationReglementTableHeader from './ModalAffectationReglementTableHeader';

// #endregion

// #region Types

export interface ModalAffectationReglementTableProps {
  montant: number;
  factures: FactureType[];
  // Le code du mode sert à désactiver les cellules d'un titre de paiement sur un produit non éligible.
  reglements: (DataReglementType & { code?: string })[];
  montantRegle: Record<string, number | string>[];
  onKeyPress: (e: React.KeyboardEvent) => void;
  onChangeMontant: (
    identifiantFacture: number,
    identifiantLigne: number,
    identifiantReglement: string | number,
    value: string,
  ) => void;
}

// #endregion Types

const ModalAffectationReglementTable = (props: ModalAffectationReglementTableProps) => {
  const { montant, factures, reglements, montantRegle, onKeyPress, onChangeMontant } = props;

  // #region Déclarations

  // État pour savoir si l'on affiche le reste à encaisser.
  const [shouldDisplayReste, setShouldDisplayReste] = React.useState<boolean>(false);

  // #endregion

  // #region Effets

  // Vérifie si le montant total réglé est égal au montant total à encaisser.
  // Auquel cas on affiche le reste à encaisser.
  React.useEffect(() => {
    if (!_.isEmpty(montantRegle)) {
      setShouldDisplayReste(_.sumBy(montantRegle, (m) => (m.montant as number) || 0) === montant);
    }
  }, [montant, montantRegle]);

  // #endregion

  return (
    <Table
      className="table-saisie"
      celled
      striped
      style={{
        borderTop: 0,
        borderBottom: 0,
        borderLeft: 0,
        marginTop: 0,
      }}
    >
      <ModalAffectationReglementTableHeader reglements={reglements} />
      <Table.Body>
        {_.map(factures, (facture, indiceFacture) => (
          <ModalAffectationReglementTableBodyRow
            indiceFacture={indiceFacture}
            facture={facture}
            montantRegle={montantRegle}
            reglements={reglements}
            shouldDisplayReste={shouldDisplayReste}
            onKeyPress={onKeyPress}
            onChangeMontant={onChangeMontant}
          />
        ))}
      </Table.Body>
      <ModalAffectationReglementTableFooter
        factures={factures}
        reglements={reglements}
        montantRegle={montantRegle}
      />
    </Table>
  );
};

export default ModalAffectationReglementTable;
